import { Hammer, Layers, PaintRoller, Home, Wrench, Sparkles, Check } from "lucide-react";
import { iconFor, testIdFor } from "@/lib/serviceCatalog";

const ICONS = { Drywall: Layers, Flooring: Hammer, "Basement Renovation": Home, Painting: PaintRoller, Handyman: Wrench, Other: Sparkles };

export const ServiceStep = ({ services, value, onChange }) => (
  <div className="grid grid-cols-2 gap-3">
    {services.map((s) => {
      const Icon = ICONS[s] || iconFor(s);
      const on = value === s;
      return (
        <button key={s} type="button" onClick={() => onChange(s)} aria-pressed={on} data-testid={`service-card-${testIdFor(s)}`}
          className={`relative flex min-h-[112px] flex-col items-start justify-between gap-3 rounded-2xl border bg-white p-4 text-left transition-[border-color,box-shadow,transform] duration-200 active:scale-[0.97] ${
            on ? "border-[color:var(--brand)] shadow-[0_0_0_3px_color-mix(in_srgb,var(--brand)_18%,transparent)]" : "border-slate-200 shadow-soft hover:border-slate-300"}`}>
          <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${on ? "bg-[color:var(--brand)] text-white" : "brand-tint text-[color:var(--brand)]"}`}>
            <Icon className="h-5 w-5" strokeWidth={1.75} />
          </span>
          <span className="text-[15px] font-semibold leading-tight text-slate-900">{s}</span>
          {on && <span className="absolute right-3 top-3 flex h-5 w-5 items-center justify-center rounded-full bg-[color:var(--brand)] text-white"><Check className="h-3 w-3" strokeWidth={3} /></span>}
        </button>
      );
    })}
  </div>
);
